<template>
  <div class="-mt-6 px-4 md:pl-11 pt-16 pb-20 bg-white rounded-t-3xl bg-[url('/images/bg-more.svg')] bg-no-repeat bg-right bg-contain">
    <div class="flex flex-col">
      <h2 class="text-2xl md:text-5xl text-center md:text-left font-semibold uppercase">{{ t('home.more.title') }}</h2>
      <div class="p-2.5 flex flex-row gap-2.5 items-center">
        <div class="shrink-0 w-12 h-12 bg-black rounded-full flex flex-col items-center justify-center">
          <ArrowRight class="w-4 text-white" />
        </div>
        <MultilangHtml class="text-md md:text-3xl text-neutral-400" :html="t('home.more.advantage1')" />
      </div>
      <div class="p-2.5 flex flex-row gap-2.5 items-center">
        <div class="shrink-0 w-12 h-12 bg-black rounded-full flex flex-col items-center justify-center">
          <ArrowRight class="w-4 text-white" />
        </div>
        <MultilangHtml class="text-md md:text-3xl text-neutral-400" :html="t('home.more.advantage2')" />
      </div>
      <div class="p-2.5 flex flex-row gap-2.5 items-center">
        <div class="shrink-0 w-12 h-12 bg-black rounded-full flex flex-col items-center justify-center">
          <ArrowRight class="w-4 text-white" />
        </div>
        <MultilangHtml class="text-md md:text-3xl text-neutral-400" :html="t('home.more.advantage3')" />
      </div>
      <div class="p-2.5 flex flex-row gap-2.5 items-center">
        <div class="shrink-0 w-12 h-12 bg-black rounded-full flex flex-col items-center justify-center">
          <ArrowRight class="w-4 text-white" />
        </div>
        <MultilangHtml class="text-md md:text-3xl text-neutral-400" :html="t('home.more.advantage4')" />
      </div>
      <div class="p-2.5 flex flex-row gap-2.5 items-center">
        <div class="shrink-0 w-12 h-12 bg-black rounded-full flex flex-col items-center justify-center">
          <ArrowRight class="w-4 text-white" />
        </div>
        <MultilangHtml class="text-md md:text-3xl text-neutral-400" :html="t('home.more.advantage5')" />
      </div>
      <p class="my-2">{{ t('home.more.outro') }}</p>
      <div class="text-center md:text-left">
        <VaButton preset="secondary" border-color="black" color="black" round class="h-[68px] !py-2.5 !pl-2.5 !pr-0" :to="{ name: 'appointment' }">
          <span class="ml-2.5">{{ t('common.bookDemo') }}</span>
          <div class="ml-5 w-[46px] h-[46px] rounded-full bg-red-600 flex flex-col items-center justify-center">
            <ArrowRight class="w-4" />
          </div>
        </VaButton>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import ArrowRight from '@/assets/icons/arrow-right.svg'
import MultilangHtml from '@/components/MultilangHtml.vue'
import { useI18n } from 'vue-i18n'
import { VaButton } from 'vuestic-ui'

const { t } = useI18n()
</script>
